import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../../common/_common.scss'
import ResponsiveInputsList from '../../../common/forms/ResponsiveInputsList'
import { Form, FormCheck, Row, Col } from 'react-bootstrap'

const helpBlockStyles = styles['help-block-font-size'] +
  ' ' + styles['margin-left-auto'] +
  ' ' + styles['margin-right-auto'] +
  ' ' + 'alert alert-danger'

class PreferredLanguages extends React.Component {
  static propTypes = {
    languages: PropTypes.array,
    selectedPreferredLanguageIds: PropTypes.array.isRequired,
    preferredLanguageSelected: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  static defaultProps = {
    languages: []
  }

  constructor (props) {
    super(props)

    this.renderLanguageCheckbox = this.renderLanguageCheckbox.bind(this)
    this.preferredLanguageSelected = this.preferredLanguageSelected.bind(this)
    this.isLanguageChecked = this.isLanguageChecked.bind(this)
  }

  preferredLanguageSelected (event) {
    this.props.preferredLanguageSelected(parseInt(event.target.value))
  }

  isLanguageChecked (language) {
    return this.props.selectedPreferredLanguageIds.indexOf(language.languageId) > -1
  }

  render () {
    const languages = this.props.languages

    return (
      <Row className={commonStyles['bg-grey']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section className={styles['languages-container']}>
            <h3>What are your preferred languages?</h3>
            {this.props.validation.help &&
              this.props.showValidationErrors &&
              <Form.Text className={helpBlockStyles}>
                {this.props.validation.help}
              </Form.Text>}
            <Form.Group >
              <ResponsiveInputsList
                isListItemChecked={this.isLanguageChecked}
                list={languages}
                renderFunction={this.renderLanguageCheckbox} />
            </Form.Group>
          </section>
        </Col>
      </Row>
    )
  }

  renderLanguageCheckbox ({ languageId, language }, checked) {
    return <Form.Check
      type='checkbox'
      key={languageId}
      checked={checked}
      value={languageId}
      onChange={this.preferredLanguageSelected}
      isInvalid={this.props.validation.isInvalid}
      label={
        <>
        <span>{language}</span>
        </>
      }>
      
    </Form.Check>
  }
}

export default (PreferredLanguages)
